/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Container from 'components/Container.jsx';
import Progress from 'components/Progress.jsx';

import './styles/SequentialProgressFooter.scss';

type Props = {
  className?: string,
  currentStep?: number,
  steps?: number,
  next?: boolean,
  nextDisabled?: boolean,
  nextButton?: React.Element<any>,
  nextButtonText?: string,
  nextButtonUrl?: string,
  onNext?: Function,
  onPrevious?: Function,
  previous?: boolean,
  previousDisabled?: boolean,
  previousButton?: React.Element<any>,
  previousButtonText?: string,
  previousButtonUrl?: string,
  progress?: boolean,
  progressColor?: 'lava' | 'caribbean' | 'sky' | 'brand' | 'midnight' | 'violet',
};

export default function SequentialProgressFooter({
  className,
  currentStep,
  steps,
  next,
  nextDisabled,
  nextButton,
  nextButtonText,
  nextButtonUrl,
  onNext,
  onPrevious,
  previous,
  previousDisabled,
  previousButton,
  previousButtonText,
  previousButtonUrl,
  progress,
  progressColor,
}: Props) {
  const previousButtonForRender = previousButton || (
    <Button
      disabled={previousDisabled}
      to={previousButtonUrl}
      color="polar-bear"
      level="secondary"
      onClick={onPrevious}>
      {previousButtonText}
    </Button>
  );

  const nextButtonForRender = nextButton || (
    <Button disabled={nextDisabled} to={nextButtonUrl} onClick={onNext}>
      {nextButtonText}
    </Button>
  );

  return (
    <footer className={cx('SequentialProgressFooter', className)}>
      <Container>
        <Buttons align="right" reverseOrder="desktop--large" split reset="desktop--large">
          {previous ? previousButtonForRender : <div />}
          {next ? nextButtonForRender : <div />}
        </Buttons>
        {progress && (
          <div className="SequentialProgressFooter-progress">
            <Progress currentStep={currentStep} steps={steps} color={progressColor} size="small" />
          </div>
        )}
      </Container>
    </footer>
  );
}

SequentialProgressFooter.defaultProps = {
  currentStep: 1,
  steps: 3,
  next: true,
  nextButtonText: 'Next',
  previous: true,
  previousButtonText: 'Back',
  progress: true,
};
